import { markdownRendererLink } from "@tradingApp/helpers/markdown/renderer/link";
import { marked } from "marked";

marked.use({ async: false });

marked.use({
  renderer: {
    link: markdownRendererLink,
  },
});

export function markdownParse(text: unknown): string {
  if (typeof text !== "string" || text.length === 0) {
    return "";
  }

  return marked(text) as string;
}
